<template>
  <div style="display: none">
    <o-map-polyline
      v-for="segment in segments"
      :key="segment.key"
      :name="segment.name"
      :path="segment.path"
      :color="segment.tier.color"
      :weight="segment.tier.weight"
      :pane="segment.tier.pane"
    />
  </div>
</template>

<script>
import OMapPolyline from '@components/Map/MapPolyline'
import { format } from 'date-fns'

export const DELAY_THRESHOLD_SECONDS = 5 * 60

const DELAYED_PANE = 'delayedTracePane'

const DELAYED_PANE_Z_INDEX = 450

const COVERED_TIER = {
  label: 'Bonne',
  segmentLabel: 'Retard ≤ 5 min',
  range: '≤ 5 min',
  color: '#A9B0BF',
  weight: 2,
}

const DELAYED_TIER = {
  label: 'Mauvaise',
  segmentLabel: 'Retard > 5 min',
  range: '> 5 min',
  color: '#D9503A',
  weight: 4,
  pane: DELAYED_PANE,
}

export const COVERAGE_TIERS = [COVERED_TIER, DELAYED_TIER]

const formatTime = (epochSeconds) => format(new Date(epochSeconds * 1000), 'dd/MM HH:mm')

const buildSegments = (points) => {
  const segments = []
  let current = null
  let previous = null

  for (const [longitude, latitude, locatedTs, createdTs] of points) {
    const tier = createdTs - locatedTs > DELAY_THRESHOLD_SECONDS ? DELAYED_TIER : COVERED_TIER
    const location = [latitude, longitude]

    if (!current || current.tier !== tier) {
      current = {
        tier,
        path: previous ? [previous.location] : [],
        startedTs: previous ? previous.locatedTs : locatedTs,
        endedTs: locatedTs,
      }
      segments.push(current)
    }

    current.path.push(location)
    current.endedTs = locatedTs
    previous = { location, locatedTs }
  }

  return segments.filter(({ path }) => path.length > 1)
}

export default {
  name: 'EditLiveReviewTrackerTraceLayer',

  components: {
    OMapPolyline,
  },

  inject: ['onMap'],

  props: {
    trace: {
      type: Object,
      required: true,
      validator: (value) => ['trackerId', 'name', 'points'].every((key) => key in value),
    },
  },

  created() {
    this.onMap.then((map) => {
      if (map.getPane(DELAYED_PANE)) {
        return
      }

      map.createPane(DELAYED_PANE)
      map.getPane(DELAYED_PANE).style.zIndex = DELAYED_PANE_Z_INDEX
    })
  },

  computed: {
    segments() {
      return buildSegments(this.trace.points).map((segment, index) => ({
        ...segment,
        key: `${this.trace.trackerId}-${index}`,
        name: this.tooltipOf(segment),
      }))
    },
  },

  methods: {
    tooltipOf({ tier, startedTs, endedTs }) {
      return [
        `<b>${this.trace.name}</b>`,
        tier.segmentLabel,
        `${formatTime(startedTs)} → ${formatTime(endedTs)}`,
      ].join('<br>')
    },
  },
}
</script>
